import { Start, Stop } from 'smg/buttons';
import { CreateFormSubmissionWithReCaptcha } from 'smg/customer-api/formsubmissions';
import { ShowError } from 'smg/errors';
import { ReportValidity } from 'smg/form';

for (const $link of Array.from(document.querySelectorAll<HTMLAnchorElement>('a.lang-switch'))) {
    $link.href += location.search;
}

const $emailForm = document.getElementById('footer-email-form') as HTMLFormElement | null;
const $emailSuccess = document.getElementById('footer-email-success');

if ($emailForm && $emailSuccess) {
    const $email = $emailForm.querySelector<HTMLInputElement>('input[name="email"]');
    const $submit = $emailForm.querySelector<HTMLButtonElement>('button[type="submit"]');
    const $reCaptchaPlaceholder = $emailForm.querySelector<HTMLElement>('.contact-recpatcha-parent');

    if ($email && $submit && $reCaptchaPlaceholder) {
        $emailForm.noValidate = true;
        $emailForm.addEventListener('submit', async e => {
            e.preventDefault();
            if (!ReportValidity($emailForm)) {
                return;
            }

            Start($submit);
            $submit.disabled = true;
            $email.disabled = true;

            try {
                // The signup persists as a `newsletter` form submission
                // (#6717); the routing automation does the user create/attach,
                // so nothing here waits on it. The payload `form` value is the
                // one the retired /users/email flows keyed on.
                await CreateFormSubmissionWithReCaptcha({
                    form: 'newsletter',
                    variant: 'footer',
                    payload: {
                        email: $email.value,
                        form: 'footer',
                    },
                }, {
                    $reCaptchaPlaceholder,
                    action: 'newsletter',
                });

                $emailForm.classList.add('d-none');
                $emailSuccess.classList.remove('d-none');
                $emailSuccess.classList.add('d-flex');
            } catch (err) {
                Stop($submit);
                $submit.disabled = false;
                $email.disabled = false;
                ShowError(err);
                throw err;
            }
        });
    }
}

const footerDropdownToggles = document.querySelectorAll('.footer-dropdown-toggle');

footerDropdownToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
        const dropdown = toggle.nextElementSibling as HTMLElement;
        if (dropdown.classList.contains('expanding') || dropdown.classList.contains('collapsing')) {
            return;
        }
        if (dropdown.classList.contains('expanded')) {
            collapse(dropdown);
        } else {
            footerDropdownToggles.forEach(t => {
                const d = t.nextElementSibling as HTMLElement;
                if (d !== dropdown && d.classList.contains('expanded')) {
                    collapse(d);
                }
            });
            expand(dropdown);
        }
    });
});

function expand(e: HTMLElement) {
    e.classList.add('expanding');
    e.style.height = `${e.scrollHeight}px`;
    setTimeout(() => {
        e.style.height = 'auto';
        e.classList.remove('expanding');
        e.classList.add('expanded');
    }, 300);
}

function collapse(e: HTMLElement) {
    e.classList.remove('expanded');
    e.classList.add('collapsing');
    e.style.height = `${e.scrollHeight}px`;
    setTimeout(() => {
        e.style.height = '0px';
        setTimeout(() => {
            e.style.height = '';
            e.classList.remove('collapsing');
        }, 300);
    }, 0);
}
